import * as React from 'react';
import { observer } from 'mobx-react';
import { Result, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import FreeCompetitionStatusPage from './FreeCompetitionStatusPage';

interface FreeCompetitionStatusPageViewProps {
    model: FreeCompetitionStatusPage;
}

const FreeCompetitionStatusPageView: React.FC<FreeCompetitionStatusPageViewProps> = observer(
    ({ model }) => {
        const { t } = useTranslation('payment');
        return (
            <Result
                status='success'
                title={t('thanksForFreeSubmission')}
                subTitle={t('thanksForFreeSubmissionDsc')}
                extra={[
                    <Button
                        type='primary'
                        key='console'
                        onClick={model.onRemoveChildPage}>
                        {t('goToMyPage')}
                    </Button>
                ]}
            />
        );
    }
);

export default FreeCompetitionStatusPageView;
